<template>
  <div class="login">
    <div class="login-cont">
      <t-message v-show="isToastshow" theme="error" icon :duration="2000" :content="message" />
      <RighttopIcon @click.native="setLoginType" :type="type" :txt="txt"></RighttopIcon>
      <QrcodeLogin v-if="loginType == true" @toRegister="toRegister" :referUrl="referUrl" />
      <LoginAccount v-else @toRegister="toRegister" :referUrl="referUrl"></LoginAccount>
      <div v-if="!loginType" class="left-info">
        <p class="p1">还没有账号？<span @click="toRegister">立即注册</span></p>
      </div>
    </div>
    <ProtocolDialog />
    <!--滑块验证-->
    <slider-verify ref="sliderVerify" @closeDialog="closeDialog" @success="onSuccess" @again="onAgain" />
  </div>
</template>

<script>
import { getQueryString, zhugeTrack } from "@/utils/utils";
import QrcodeLogin from "@/components/login/qrcodeLogin";
import LoginAccount from "@/components/login/login-account";
import { mapState, mapMutations } from "vuex";
import RighttopIcon from "@/components/common/righttopIcon";
import ProtocolDialog from "@/components/common/protocolDialog";
import sliderVerify from "@/components/common/puzzleVerify";
export default {
  name: "login",
  components: {
    QrcodeLogin,
    LoginAccount,
    RighttopIcon,
    ProtocolDialog,
    sliderVerify
  },

  data() {
    return {
      // 是否显示滑块验证
      dialogVisible: true,
      type: 2,
      txt: "登录", //切换手机与微信需要的参数
      loginType: true, // 登录类型  1、微信二维码登录  2、手机验证码登录  3、账号密码登录
      codeLogin: false, // 回车课堂登录
      referUrl: "", // 登录后跳转的页面 （url携带）
    };
  },
  computed: {
    ...mapState(["isToastshow", "message", "protocolDialogVisible", "isShowSliderVerify"]),
  },
  mounted() {
    // 获取登录页跳转的页面
    this.referUrl = getQueryString("refer")
      ? decodeURIComponent(getQueryString("refer"))
      : "";
    zhugeTrack("进入_登录页",{
      '终端':"Web"
    });
    if(window.location.search.indexOf('match')>-1){
      this.loginType=false
    }
  },

  methods: {
    ...mapMutations(["sevendayLogin"]),
    onSuccess() {},
    /* 滑动验证异常*/
    onAgain() {
      this.$message.error("滑动操作异常，请重试")
    },
    closeDialog() {},
    //是否选择七天免登录
    checkSelect() {
      this.sevendayLogin();
    },
    //切换微信注册or登录注册
    setLoginType() {
      this.loginType = !this.loginType;
      if (!this.loginType) {
        this.type = 1;
        this.txt = "登录";
      } else {
        this.type = 2;
        this.txt = "登录";
      }
    },

    // 去注册页面
    toRegister() {
      this.$router.push({
        name: "register",
        query: {
          refer: this.referUrl ? this.referUrl : undefined,
          codeLogin: this.codeLogin ? this.codeLogin : undefined,
        },
      });
    },
  },

  metaInfo() {
    return {
      title: window.location.search.indexOf('match')>-1?'用户登录 - 传智杯大赛官网-全国大学生计算机应用能力与数字素养大赛':'用户登录 - 博学谷·黑马程序员线上品牌',
      meta: [
        {
          name: "keyWords",
          content: "登录入口,员登录系统,网址,博学谷",
        },
        {
          name: "description",
          content:
            "博学谷官网学员登录入口，学员登录后可以在线学习，通过线上视频课的形式学习自己所报名的课程，可以选择Java、Python、云计算大数据、前端开发、UI设计、人工智能、软件测试与移动开发、PHP、电商运营等课程。",
        },
      ],
      link: [{ rel: "icon", type: "image/x-icon", href: window.location.search.indexOf('match')>-1?'/favicon.czb.ico':'/favicon.ico' }]
    };
  },
};
</script>

<style lang="scss" scoped>
.sliderVerify {
  ::v-deep .el-dialog {
    background: linear-gradient(180deg, #F0F5FF 0%, #FFFFFF 100%);
    border-radius: 6px;

    .el-dialog__title {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }

    .el-dialog__body {
      padding: 15px 20px 30px;
    }
  }

}

@media screen and (max-width: 1280px) {
  .login-cont {
    right: 120px !important;
  }
}

@media screen and (min-width: 1920px) {
  .login-cont {
    right: 440px !important;
  }
}

@media screen and (min-width: 1281px) and (max-width: 1919px) {
  .login-cont {
    right: 200px !important;
  }
}

.login {
  ::v-deep input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }

  .t-message {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1d2129;

    height: 48px;
    background: #ffffff;
    box-shadow: 0px 12px 40px 16px rgba(8, 25, 93, 0.03),
      0px 8px 20px 0px rgba(8, 25, 93, 0.06),
      0px 4px 8px 0px rgba(8, 25, 93, 0.08);
    border-radius: 4px;
    border: 1px solid #e5e6eb;
    width: max-content;
  }

  .toast {
    z-index: 999;
    position: absolute;
    top: 40%;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 20px;
    z-index: 1000;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    font-size: 26px;
    padding: 30px 71px;
    text-align: center;
    white-space: nowrap;
  }

  .login-cont {
    position: fixed;
    width: 464px;
    height: 520px;
    background: #ffffff;
    box-shadow: 0px 12px 40px 16px rgba(8, 25, 93, 0.03),
      0px 8px 20px 0px rgba(8, 25, 93, 0.06),
      0px 4px 8px 0px rgba(8, 25, 93, 0.08);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 8px;

    ::v-deep .user-login {
      .other-tab {
        p {
          color: #4e5969;
          white-space: nowrap;
        }
      }
    }

    ::v-deep .phone-login {
      .get-code {
        color: #4e5969 !important;

        &:hover {
          color: #165dff !important;
        }
      }
    }

    ::v-deep .el-form-item__content {
      line-height: normal;
    }

    ::v-deep .login-from {
      margin-top: 30px;

      .el-input__inner {
        width: 368px;
        height: 40px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 4px;
        line-height: 40px;

        padding-left: 16px;
        box-sizing: border-box;
        border: 1px solid #e5e6eb;

        &:focus {
          border: 1px solid #165dff;
        }
      }

      .is-error {
        .el-input__inner {
          border: 1px solid #f53f3f;
        }

        .el-form-item__error {
          color: #f53f3f;
        }
      }
    }

    ::v-deep .login-btn {
      button {
        width: 368px;
        height: 44px;
        border-radius: 4px;
        margin-top: 16px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        letter-spacing: 0;
        cursor: pointer;
        border: none;
        outline: none;
        text-align: center;

        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background: #165dff;

        &:hover {
          background-color: #4080ff;
        }
      }

      p {
        font-family: PingFangSC-Regular;
        font-size: 14px;

        &:hover {
          color: #165dff;
        }

        span {
          color: #4e5969;
          cursor: pointer;
        }
      }
    }
  }

  .left-info {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 51px;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);

    p {
      height: 22px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 22px;
    }

    i {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 5px;
      vertical-align: middle;
      position: relative;
      cursor: pointer;
    }

    .empty {
      background: url("../assets/register/icon-bxg-empty.png") no-repeat;
      background-size: 100% 100%;
    }

    .select {
      background: url("../assets/register/icon-bxg-select.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .p1 {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 22px;
    text-align: center;

    span {
      color: #165dff;
      cursor: pointer;

      &:hover {
        color: #4080ff;
      }
    }
  }
}</style>
